import { createThunkEffect } from "../../utilities/ActionUtility";
import * as FilterableSubscriptionRequestEffect from "./FilterableSubscriptionRequestEffect";

export const REQUEST_ALL_FILTERABLE_SUBSCRIPTION_REQUESTS = "FilterableSubscriptionRequestEffect.REQUEST_ALL_FILTERABLE_SUBSCRIPTION_REQUESTS";
export const REQUEST_ALL_FILTERABLE_SUBSCRIPTION_REQUESTS_FINISHED = "FilterableSubscriptionRequestEffect.REQUEST_ALL_FILTERABLE_SUBSCRIPTION_REQUESTS_FINISHED";

export function requestAllFilterableSubscriptionRequests() {
    return async (dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_FILTERABLE_SUBSCRIPTION_REQUESTS, FilterableSubscriptionRequestEffect.requestAllFilterableSubscriptionRequests);
    };
}

export const CREATE_FILTERABLE_SUBSCRIPTION_REQUEST = "FilterableSubscriptionRequestEffect.CREATE_FILTERABLE_SUBSCRIPTION_REQUEST";
export const CREATE_FILTERABLE_SUBSCRIPTION_REQUEST_FINISHED = "FilterableSubscriptionRequestEffect.CREATE_FILTERABLE_SUBSCRIPTION_REQUEST_FINISHED";

export function createFilterableSubscriptionRequest(userId, newFilterableSubscriptionRequest) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, CREATE_FILTERABLE_SUBSCRIPTION_REQUEST, FilterableSubscriptionRequestEffect.createFilterableSubscriptionRequest, userId, newFilterableSubscriptionRequest);
    };
}

export const CONFIRM_FILTERABLE_SUBSCRIPTION_REQUEST = "FilterableSubscriptionRequestEffect.CONFIRM_FILTERABLE_SUBSCRIPTION_REQUEST";
export const CONFIRM_FILTERABLE_SUBSCRIPTION_REQUEST_FINISHED = "FilterableSubscriptionRequestEffect.CONFIRM_FILTERABLE_SUBSCRIPTION_REQUEST_FINISHED";

export function confirmFilterableSubscriptionRequest(subscriptionRequestId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch, CONFIRM_FILTERABLE_SUBSCRIPTION_REQUEST, FilterableSubscriptionRequestEffect.confirmFilterableSubscriptionRequest, subscriptionRequestId);
    };
}

export const REJECT_FILTERABLE_SUBSCRIPTION_REQUEST = "FilterableSubscriptionRequestEffect.REJECT_FILTERABLE_SUBSCRIPTION_REQUEST";
export const REJECT_FILTERABLE_SUBSCRIPTION_REQUEST_FINISHED = "FilterableSubscriptionRequestEffect.REJECT_FILTERABLE_SUBSCRIPTION_REQUEST_FINISHED";

export function rejectFilterableSubscriptionRequest(subscriptionRequestId) {
    return async (dispatch) => {
        await createThunkEffect(dispatch,REJECT_FILTERABLE_SUBSCRIPTION_REQUEST, FilterableSubscriptionRequestEffect.rejectFilterableSubscriptionRequest, subscriptionRequestId);
    };
}
